export default __webpack_public_path__ + "static/media/cooperate4.ad06806d.png";